//
import Service from '@/services/api/service'
import OrdererModel from '@/models/Warehouse/WhOrderer'

/**
 * This class describes a wh orderer.
 *
 * @class      WhOrderer (name)
 */
export default class WhOrderer extends Service {

  /**
   * Return the wh orderer resource.
   *
   * @return     {Object}  The wh orderer model
   */
  resource() {
    return OrdererModel
  }

  /**
   * Returns a wh orderer list.
   *
   * @return     {Object}  The wh orderer list request.
   */
  toList() {
    return this
      .append('')
      .include(
        'g_supervisor_user.hr_employee',
        'pch_provider',
        'pch_provider_branch_offices',
        'pch_purchase_orders.pch_purchase_order_state',
        'wh_orderer_priority',
        'wh_warehouse',
      )
  }
}
